export default __webpack_public_path__ + "7924e70062fb0b731bee8095abc9727f.png";